import { apiClient, type ApiResult } from '@/services/apiClient';

export interface MapsConfiguration {
  enabled: boolean;
  allowApproximateGeocoding: boolean;
  mapId: string | null;
  workspaceKeyPresent: boolean;
  secretStorageReady: boolean;
  updatedAt: string | null;
}
export interface MapsRuntimeConfiguration {
  enabled: boolean;
  allowApproximateGeocoding: boolean;
  mapId: string | null;
  browserKey: string | null;
  source: 'deployment' | 'workspace';
}
export interface MapsConfigurationPatch {
  expectedUpdatedAt: string | null;
  enabled: boolean;
  allowApproximateGeocoding: boolean;
  mapId: string | null;
  browserKey?: string;
  useDeploymentKey?: boolean;
}
async function unwrap<T>(promise: Promise<ApiResult<T>>): Promise<T> {
  const result = await promise;
  if (!result.ok || !result.data)
    throw new Error(result.error ?? 'Google Maps settings could not be loaded.');
  return result.data;
}
export const mapsConfigurationApi = {
  configuration: () => unwrap(apiClient.get<MapsConfiguration>('/v1/maps/configuration')),
  update: (body: MapsConfigurationPatch) =>
    unwrap(apiClient.patch<MapsConfiguration>('/v1/maps/configuration', body)),
  runtime: () => unwrap(apiClient.get<MapsRuntimeConfiguration>('/v1/maps/runtime-configuration')),
};
